export class BaseApi {
  public static cache: any = {};
}
